import { render, staticRenderFns } from "./AthleteTeamsSummary.vue?vue&type=template&id=31dbc73b&"
import script from "./AthleteTeamsSummary.vue?vue&type=script&lang=ts&"
export * from "./AthleteTeamsSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports